import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { useParams, useNavigate, generatePath } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Title from '../../../components/Title';
import StoreList from '../../../components/StoreList';
import { getSelectedStore, selectStore } from '../../../store/slices/storesSlice';
import { currentLang } from '../../../../../utils/lang';
import { routePaths } from '../../../router/paths';
import { getStoreById } from '../../../store/selectors/storesSelectors';
const AllStores = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const currentLocale = currentLang();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const storeByIdSelector = useMemo(getStoreById, [id]);
    // @ts-ignore
    const selectedStoreByRouteId = useSelector(state => storeByIdSelector(state, id));
    const selectedStore = useSelector(getSelectedStore);
    const routeStore = id ? selectedStoreByRouteId : null;
    useEffect(() => {
        if (routeStore && routeStore !== selectedStore) {
            dispatch(selectStore(routeStore));
        }
    }, [routeStore]);
    useEffect(() => {
        if (selectedStore && selectedStore !== routeStore) {
            navigate(generatePath(routePaths.AllStoresWithParameter[currentLocale], { id: String(selectedStore.id) }), {
                replace: true,
            });
        }
    }, [selectedStore]);
    return (_jsx("div", { children: _jsx(StoreList, { askForPosition: !id, headerComponent: _jsx(Title, { title: t('store_locator.stores.all.title'), viewInMap: true }) }) }));
};
export default AllStores;
